import { branch, compose, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import {
  KnownPMILoaded,
  EstPMILoaded,
  ModuleShown,
  EVENTS_LABELS
} from 'src/constants/trackingEvents'
import { selectHomeValue } from 'src/store/selectors/home/metadata'
import {
  selectConventionalPMI,
  selectEstimatedPMI,
  selectLTVPercent,
  showPMIContainer
} from 'src/store/selectors/home/pmi'
import { withElementRef } from 'src/composables'
import { PmiPanel } from 'src/constants/notificationRefs'
import { dispatchEvent } from 'src/helpers/tagManager'
import withEventOnceOnMount from 'src/composables/withEventOnceOnMount'

const MortgageInsuranceContainer = compose(
  connect(state => {
    const show = showPMIContainer(state)

    if (!show) {
      return { show }
    }

    const manualPmi = selectConventionalPMI(state)

    dispatchEvent(manualPmi ? KnownPMILoaded : EstPMILoaded)

    return {
      show,
      manualPmi,
      avm: selectHomeValue(state),
      hasManualPmi: manualPmi > 0,
      estimatedPmi: selectEstimatedPMI(state),
      ltvPercent: selectLTVPercent(state)
    }
  }),
  branch(({ show }) => !show, renderNothing),
  withElementRef(PmiPanel),
  withEventOnceOnMount(ModuleShown, {
    eventLabel: EVENTS_LABELS.PmiSection
  })
)

export default MortgageInsuranceContainer
